import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { AVAILABLE_APP_SUBSCRIPTIONS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const AvailableAppSubscriptionsService = ComposedComponent =>
  reduxFetch([
    {
      resource: AVAILABLE_APP_SUBSCRIPTIONS_RESOURCE,
      method: 'get',
      request: (organisationId, t) => ({
        url: addParametersToUri(apiRoutes.communityApps(), { organisationId }),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppSubscriptionsFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AvailableAppSubscriptionsService;
